export default function isGenericFolder(folder) {
  return !!(
    folder.contacts ||
    folder.nonContacts ||
    folder.groups ||
    folder.broadcasts ||
    folder.bots
  );
}
